<template>
	<div class="tips-modal" v-show="tipsShow">
		<div class="tips-modal.box">
			<h1>感谢留言<small>我们会尽快与您联系</small></h1>
			<button @click="closeTips">关闭</button>
		</div>
	</div>
</template>

<script>
	export default{
		props:['tipsShow'],
		methods:{
			closeTips(){
				this.$emit('closeTipsEvent',false)
			}
		}
	}
</script>

<style lang="scss">
	@include component(tips-modal){
		width: 100%;
		min-width: $minWidth;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.2);
		z-index: 9999999;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #333333;
		
		@include part(box) {
			width: 320px;
			height: 210px;
			box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
			border-radius: 10px;
			background-color: #ffffff;
			border-top: 10px solid #FF7E00;
			
		
			h1 {
				margin: 0;
				font-size: 30px;
				color: #FF7E00;
				margin-top: 38px;
		
				small {
					display: block;
					font-size: 18px;
					color: #333333;
					margin-top: 14px;
					font-weight: normal;
				}
			}
		
			button {
				width: 190px;
				height: 40px;
				border-radius: 5px;
				background-color: #f47227;
				border: none;
				outline: none;
				color: #FFFFFF;
				line-height: 40px;
				margin-top: 25px;
				cursor: pointer;
			}
		}
	}
</style>
